<script>
    import { push } from "svelte-spa-router";
    import Button from "../ui_elements/Button.svelte";
    import { onMount } from "svelte";
    import { getAnswerHighlights } from "../utility.js";
    import PageBox from "../layouts/PageBox.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import ScoreChart from "./results-components/ScoreChart.svelte";

    const pageTitle = "Deine Highlights";
    const description = "";
    let data = "";
    // for the faehigkeiten chart
    const topRow = {columnName: "Fähigkeit", leftLabel: "kann ich nicht so gut", rightLabel: "kann ich sehr gut"}

    onMount(async() => {
        data = await getAnswerHighlights();
        console.log(data);
    });
</script>

<PageBox {pageTitle} {description}>
    {#if data}
        <ContentBox>
            <h1 class="font-bold">Deine Interessen</h1>
            <p>Der Interessensteil dient dazu, wesentliche Interessen festzustellen, da diese eine notwendige Grundlage für stimmige Berufsempfehlungen bilden. Im Fragebogen werden Interessen aus vielen verschiedenen Bereichen abgefragt, auch solche, an die vielleicht noch nicht gedacht wurde. </p><br>
            <p>Die Tätigkeiten aus den folgenden Bereichen haben dich im Schnitt am meisten interessiert:</p>
            <ol class="list-decimal list-inside">
                {#each Object.entries(data['interessen_subcategories']) as [subcategory, entry]}
                    <li><b>{subcategory}</b> ({(entry.score * 100).toFixed(0)}% Übereinstimmung)</li>
                    {#each entry.highlights as highlight}
                        <ul>
                            <li>{highlight}</li>
                        </ul>
                    {/each}
                    <br>
                {/each}
            </ol>
        </ContentBox>

        <ContentBox>
            <h1 class="font-bold">Deine Stärken</h1>
            <p>Im Fähigkeitenteil dient dazu, Berufsempfehlungen zu finden, die gut zu deinen persönlichen Stärken passen. In den folgenden Fähigkeiten siehst du deine Stärken:</p>
            <ol class="list-decimal list-inside">
                {#each Object.entries(data['faehigkeiten_subcategories']) as [subcategory, entry]}
                    <li><b>{subcategory}</b> ({(entry.score * 100).toFixed(0)}% Übereinstimmung)</li>
                    {entry.description}
                    <br>
                    <p>Insbesondere in den folgenden Antworten von dir zeigt sich, dass {subcategory} eine Stärke von dir ist:</p>
                    {#each entry.highlights as highlight}
                        <ul>
                            <li>{highlight}</li>
                        </ul>
                    {/each}
                    <br>
                {/each}
            </ol>

            <ScoreChart rows={data['faehigkeiten_subcategory_scores']} {topRow} exportable=true />
        </ContentBox>

        <ContentBox>
            <h1 class="font-bold">Deine Zielgruppen</h1>
            <p>Im Zielgruppenteil wählst du aus einer Liste aus, mit welchen Personengruppen du gerne arbeiten willst. Dir waren dabei die folgenden Gruppen am wichtigsten:</p>
            <ul>
                {#each data['zielgruppen'] as subcategory}
                    <li>{subcategory}</li>
                {/each}
            </ul>
        </ContentBox>

        <ContentBox>
            <h1 class="font-bold">Deine Gegenstände</h1>
            <p>In diesem Teil wählst du aus einer Liste aus, mit welchen Gegenständen du gerne arbeiten willst. Dir waren dabei die folgenden Gegenstände am wichtigsten:</p>
            <ul>
                {#each data['gegenstaende'] as subcategory}
                    <li>{subcategory}</li>
                {/each}
            </ul>
        </ContentBox>

        <ContentBox>
            <h1 class="font-bold">Deine Schulfächer</h1>
            <p>Im Schulfächerteil gibst du an, wie gerne du in deiner beruflichen Zukunft mit verschiedenen Schulfächern zu tun haben willst. Mit den folgenden Schulfächern willst du dich weiterhin auseinandersetzen:</p>
            <ul>
                {#each data['schulfaecher'] as schulfach}
                    <li>{schulfach}</li>
                {/each}
            </ul>
        </ContentBox>

        <ContentBox>
            <h1 class="font-bold">Deine Orte</h1>
            <p>Viele Berufe sind mit einem konkreten Arbeitsumfeld verbunden. Im Orteteil gibst du an, wo du die das spätere Arbeiten vorstellen kannst. An den folgenden Orten würdest du am liebsten arbeiten:</p>
            <ul>
                {#each data['orte'] as ort}
                    <li>{ort}</li>
                {/each}
            </ul>
        </ContentBox>
    {:else}
        <ContentBox>
            Loading...
        </ContentBox>
    {/if}

    <div class="flex mx-4 mb-2 justify-between w-2/3" style="min-width: 600px">
        <Button on:click={ () => push('/questionnaire') }>Zurück zum Fragebogen</Button>
        <Button on:click={() => push('/results')} variant="submit">Weiter zur Auswertung</Button>
    </div>

</PageBox>
